__turbopack_context__.v({
  "container": "Layout-module-scss-module__7sXoyq__container",
  "dark": "Layout-module-scss-module__7sXoyq__dark",
  "main": "Layout-module-scss-module__7sXoyq__main",
  "modalOpen": "Layout-module-scss-module__7sXoyq__modalOpen",
});
